import React, { useState, useEffect } from 'react';
import localforage from 'localforage';
import { motion, AnimatePresence } from 'framer-motion';
import CampManagementForm from './CampManagementForm';

const BASE_URL = 'https://lager-app-api.sunrise-avengers.ch:443';

const CampsOverviewScreen = () => {
  const [camps, setCamps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedCamp, setSelectedCamp] = useState(null);
  const [filterText, setFilterText] = useState('');
  const [expandedCampId, setExpandedCampId] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: 'startDate', direction: 'asc' });


  const handleFormClose = (shouldRefresh = false) => {
    console.log("Form wird geschlossen, Refresh:", shouldRefresh);
    setShowForm(false);
    setSelectedCamp(null);
    if (shouldRefresh) {
      fetchCamps();
    }
  };
  const deleteCamp = async (campId) => {
    try {
     const token = await localforage.getItem('token');
     if (!token) {
       throw new Error('Not logged in - please login again');
     }
    
     const response = await fetch(`${BASE_URL}/api/camps/${campId}`, {
       method: 'DELETE',
       headers: {
         'Authorization': `Bearer ${token}`
       }
     });
    
     if (!response.ok) {
       throw new Error('Error deleting camp');
     }
    
     fetchCamps();
    } catch (err) {
     setError(err.message);
    }
    };
  const styles = {
    container: {
      padding: '30px',
      maxWidth: 'auto',
      margin: '0 auto',
      backgroundColor: '#f8f9fa',
      minHeight: '100vh',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '30px',
      padding: '20px 0',
    },
    title: {
      fontSize: '28px',
      color: '#2c3e50',
      margin: 0,
      fontWeight: '600',
    },
    addButton: {
      backgroundColor: '#27ae60',
      color: 'white',
      border: 'none',
      padding: '14px 28px',
      borderRadius: '12px',
      cursor: 'pointer',
      fontSize: '16px',
      fontWeight: '500',
      transition: 'all 0.3s ease',
      boxShadow: '0 2px 8px rgba(39, 174, 96, 0.2)',
      '&:hover': {
        backgroundColor: '#219a52',
        transform: 'translateY(-1px)',
      }
    },
    controls: {
      display: 'flex',
      gap: '20px',
      marginBottom: '25px',
      flexWrap: 'wrap',
    },
    searchInput: {
      flex: '1',
      minWidth: '250px',
      padding: '15px',
      borderRadius: '12px',
      border: '1px solid #e0e0e0',
      fontSize: '16px',
      backgroundColor: 'white',
      transition: 'all 0.3s ease',
      outline: 'none',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    },
    sortSelect: {
      padding: '15px',
      borderRadius: '12px',
      border: '1px solid #e0e0e0',
      fontSize: '16px',
      backgroundColor: 'white',
      cursor: 'pointer',
      outline: 'none',
    },
    campCard: {
      backgroundColor: 'white',
      borderRadius: '16px',
      margin: '15px 0',
      overflow: 'hidden',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      transition: 'all 0.5s ease',
      border: '1px solid #edf2f7',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 12px rgba(0,0,0,0.1)',
      }
    },
    campHeader: {
      padding: '20px 24px',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid #edf2f7',
      backgroundColor: '#ffffff',
    },
    campInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
      flex: 1,
    },
    campTitle: {
      margin: 0,
      fontSize: '18px',
      color: '#2d3748',
      fontWeight: '600',
    },
    campDate: {
      color: '#718096',
      fontSize: '14px',
      fontWeight: '500',
    },
    statusBadge: {
      padding: '6px 12px',
      borderRadius: '20px',
      fontSize: '14px',
      fontWeight: '500',
      textAlign: 'center',
      minWidth: '100px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: "6px",
    },
    statusActive: {
      backgroundColor: '#c6f6d5',
      color: '#2f855a',
    },
    statusPast: {
      backgroundColor: '#e2e8f0',
      color: '#4a5568',
    },
    statusFuture: {
      backgroundColor: '#bee3f8',
      color: '#2b6cb0',
    },
    expandedContent: {
      padding: '24px',
      backgroundColor: '#ffffff',
      borderTop: '1px solid #edf2f7',
    },
    description: {
      margin: '0 0 20px 0',
      color: '#4a5568',
      lineHeight: '1.6',
      fontSize: '16px',
    },
    buttonGroup: {
      display: 'flex',
      gap: '12px',
    },
    button: {
      padding: '12px 24px',
      borderRadius: '8px',
      border: 'none',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    editButton: {
      backgroundColor: '#4299e1',
      color: 'white',
      '&:hover': {
        backgroundColor: '#3182ce',
      }
    },
    deleteButton: {
      backgroundColor: '#f56565',
      color: 'white',
      '&:hover': {
        backgroundColor: '#e53e3e',
      }
    },
    moreButton: {
      backgroundColor: 'transparent',
      border: 'none',
      cursor: 'pointer',
      padding: '8px 16px',
      color: '#718096',
      fontSize: '14px',
      transition: 'all 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
    },
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    modalContent: {
      backgroundColor: 'white',
      borderRadius: '20px',
      padding: '32px',
      width: '90%',
      maxWidth: '700px',
      maxHeight: '90vh',
      overflow: 'auto',
      position: 'relative',
      boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)',
    },
    errorMessage: {
      backgroundColor: '#fed7d7',
      color: '#c53030',
      padding: '16px 24px',
      borderRadius: '12px',
      marginBottom: '24px',
      fontSize: '14px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    },
    loadingSpinner: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '200px',
      color: '#718096',
      fontSize: '18px',
    },
    noResults: {
      textAlign: 'center',
      padding: '40px',
      color: '#718096',
      fontSize: '16px',
      backgroundColor: 'white',
      borderRadius: '16px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    }
  };

  useEffect(() => {
    fetchCamps();
  }, []);

  const fetchCamps = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = await localforage.getItem('token');
      if (!token) {
        throw new Error('Nicht eingeloggt - bitte erneut anmelden');
      }

      const response = await fetch(`${BASE_URL}/api/camps`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Fehler beim Laden der Lager');
      }

      const data = await response.json();
      setCamps(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const getStatus = (startDate, endDate) => {
    const now = new Date();
    const start = new Date(startDate);
    const end = new Date(endDate);

    if (now < start) {
      return { text: 'Upcoming', style: styles.statusFuture };
    } else if (now > end) {
      return { text: 'Past', style: styles.statusPast };
    }
    return { text: 'Active', style: styles.statusActive };
  };

  const handleSort = (key) => {
    setSortConfig({
      key,
      direction: sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc'
    });
  };

  const sortedCamps = [...camps].sort((a, b) => {
    const direction = sortConfig.direction === 'asc' ? 1 : -1;
    if (sortConfig.key === 'status') {
      const statusA = getStatus(a.startDate, a.endDate).text;
      const statusB = getStatus(b.startDate, b.endDate).text;
      return direction * statusA.localeCompare(statusB);
    }
    return direction * (new Date(a[sortConfig.key]) - new Date(b[sortConfig.key]));
  });

  const filteredCamps = sortedCamps.filter(camp =>
    camp.title.toLowerCase().includes(filterText.toLowerCase()) ||
    camp.description?.toLowerCase().includes(filterText.toLowerCase())
  );

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('de-DE');
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loadingSpinner}>Loading...</div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Camp Management</h1>
        <button 
          style={styles.addButton}
          onClick={() => setShowForm(true)}
        >
          + New Camp
        </button>
      </div>

      {error && <div style={styles.errorMessage}>{error}</div>}

      <div style={styles.controls}>
        <input
          type="text"
          placeholder="Search camps..."
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          style={styles.searchInput}
        />
        <select 
          style={styles.sortSelect}
          onChange={(e) => handleSort(e.target.value)}
          value={sortConfig.key}
        >
          <option value="startDate">Sort by Start Date</option>
          <option value="endDate">Sort by End Date</option>
          <option value="status">Sort by Status</option>
        </select>
      </div>

      <AnimatePresence>
        {filteredCamps.length === 0 ? (
          <div style={styles.noResults}>No camps found matching your search.</div>
        ) : (
          filteredCamps.map(camp => (
            <motion.div
              key={camp.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
              style={styles.campCard}
            >
              <div 
                style={styles.campHeader}
                onClick={() => setExpandedCampId(expandedCampId === camp.id ? null : camp.id)}
              >
                <div style={styles.campInfo}>
                  <div>
                    <h3 style={styles.campTitle}>{camp.title}</h3>
                    <span style={styles.campDate}>
                      {formatDate(camp.startDate)} - {formatDate(camp.endDate)}
                    </span>
                  </div>
                  <div style={{
                    ...styles.statusBadge,
                    ...getStatus(camp.startDate, camp.endDate).style
                  }}>
                    {getStatus(camp.startDate, camp.endDate).text}
                  </div>
                </div>
                <button style={styles.moreButton}>
                  {expandedCampId === camp.id ? 'Show Less' : 'Show More'}
                </button>
              </div>

              <AnimatePresence>
                {expandedCampId === camp.id && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.4 }}
                    style={styles.expandedContent}
                  >
                    <p style={styles.description}>{camp.description || 'No description available.'}</p>
                    <div style={styles.buttonGroup}>
                      <button
                        style={{...styles.button, ...styles.editButton}}
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedCamp(camp);
                          setShowForm(true);
                        }}
                      >
                        Edit Camp
                      </button>
                      <button
                        style={{...styles.button, ...styles.deleteButton}}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (window.confirm('Are you sure you want to delete this camp?')) {
                            deleteCamp(camp.id);
                          }
                        }}
                      >
                        Delete Camp
                      </button>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))
        )}
      </AnimatePresence>

      {showForm && (
        <CampManagementForm
          onClose={handleFormClose}
          initialData={selectedCamp}
        />
      )}
    </div>


);

// Move deleteCamp inside the component to access fetchCamps and setError

};

export default CampsOverviewScreen;